"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var BellStrike = function (_a) {
    var fill = _a.fill, props = __rest(_a, ["fill"]);
    return (React.createElement("svg", __assign({ fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props),
        React.createElement("path", { d: "M22.85 18.526a.987.987 0 0 1-.032.05l-3.244-3.244a18.712 18.712 0 0 1-1.016-2.975c-.162-.649-.268-1.313-.366-1.927l-.048-.295c-.116-.714-.234-1.363-.43-1.974a6.003 6.003 0 0 0-8.685-3.375L7.576 3.333a8.003 8.003 0 0 1 12.041 4.215c.247.767.384 1.546.502 2.266l.05.312c.099.619.19 1.188.33 1.746a16.71 16.71 0 0 0 1.265 3.42l1.13 2.26a1 1 0 0 1-.043.974zM12 21a2 2 0 0 1-2-2H8a4 4 0 0 0 8 0h-2a2 2 0 0 1-2 2z", fill: fill || 'currentColor' }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.899 6.313 2.293 3.707l1.414-1.414 18 18-1.414 1.414L17.586 19H2a1 1 0 0 1-.894-1.447l1.13-2.262c.545-1.09.97-2.237 1.265-3.42.14-.557.231-1.127.33-1.745l.05-.312c.118-.72.255-1.498.502-2.265.138-.43.31-.842.516-1.236zm1.508 1.509L15.586 17H3.618l.407-.814a18.706 18.706 0 0 0 1.417-3.829c.162-.649.268-1.313.366-1.927l.048-.295c.116-.714.234-1.362.43-1.974.038-.114.078-.228.121-.34z", fill: fill || 'currentColor' })));
};
exports.default = BellStrike;
